import { render } from "./BlogFive.vue?vue&type=template&id=f96cef60&scoped=true"
import script from "./BlogFive.vue?vue&type=script&lang=js"
export * from "./BlogFive.vue?vue&type=script&lang=js"

import "./BlogFive.vue?vue&type=style&index=0&id=f96cef60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96cef60"]])

export default __exports__